import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { sharingApi } from '@app/shared/api'
import type { PulseShareUser } from '../types/pulse-share'
import { pulseShareTypes } from '../types/pulse-share'
import { canAccessType } from './utils'
import { SfLog } from '@app/adapters/logger'

export const usePulseShare = defineStore('pulseShare', () => {
  const isCurrentObjectBlocked = ref<boolean>(false)
  const currentShares = ref<Array<PulseShareUser>>([])
  const requestCompleted = ref<boolean>(false)

  function setCurrentObjectBlocked(isBlocked: boolean): void {
    isCurrentObjectBlocked.value = isBlocked
  }

  const isSharedForPrepare = computed(() => {
    return (
      currentShares.value.filter(canAccessType(pulseShareTypes.PREPARE))
        .length > 0
    )
  })

  const isSharedForReview = computed(() => {
    return (
      currentShares.value.filter(canAccessType(pulseShareTypes.REVIEW)).length >
      0
    )
  })

  const isShared = computed(() => {
    return isSharedForPrepare.value || isSharedForReview.value
  })

  async function refreshPulseSharesData(
    ledgerId: number,
    sharedObjectId: number
  ): Promise<void> {
    requestCompleted.value = false
    try {
      const data = await sharingApi.getPulseShareData({
        ledgerId,
        sharedObjectId,
      })
      if (data !== null) {
        currentShares.value = data.users
      }
      requestCompleted.value = true
    } catch (e) {
      if (e instanceof Error) {
        SfLog.warn('Failed to get Pulse share data', {
          extra: {
            ledgerId,
            sharedObjectId,
          },
        })
      }
    }
  }

  function setCurrentShares(data: Array<PulseShareUser>): void {
    currentShares.value = data
  }

  return {
    refreshPulseSharesData,
    isShared,
    isSharedForPrepare,
    isSharedForReview,
    isCurrentObjectBlocked,
    setCurrentObjectBlocked,
    currentShares,
    setCurrentShares,
    requestCompleted,
  }
})
